"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Range_1 = __importDefault(require("../../../Util/Range"));
const TrainingInterface_1 = require("../../../BusinessLogicLayer/TrainingInterface");
const clock_1 = require("@almservices-cl/clock");
const Iterator_1 = __importDefault(require("../Maker/Iterator"));
// TODO: drop subscriptions in here, it is only pbp10 trait
class Nutrition {
    constructor(dateTimeModifier, dateTimeProvider, userRepository, nutritionRepository, tokenService, periodPicker, customerList, customerRepository, dayTypeRepository) {
        this.getNutritionProgressByDate = async (customerId, date) => {
            const user = await this.userRepository.getUserByToken(await this.tokenService.getValidToken());
            const customer = await this.customerList.fetchCustomer(customerId);
            const dayTypePromise = this.dayTypeRepository.getDayType(customerId, date);
            try {
                const period = this.periodPicker.pickPeriod(customer.periods, new Range_1.default(date, date));
                return await this.nutritionRepository.getNutritionProgressByDay(user.id, period.periodId, this.dateTimeModifier.daysDiff(period.startDate, date));
            }
            catch (e) {
                return {
                    date,
                    method: customer.method,
                    meals: [],
                    dayType: (await dayTypePromise),
                    calorieBudgetInfo: null,
                };
            }
        };
        this.fetchCalorieBudgets = async (customerId, dateRange) => {
            const map = new Map();
            const budget = await this.customerRepository.getCalorieBudget(customerId);
            return map.set(`${dateRange.from}~${dateRange.to}`, budget);
        };
        this.fetchNutritionProgressByDateRange = async (_userId, range) => {
            const dates = (0, clock_1.getDatesOfDateRange)(range);
            const nutritionTrackMethodIterator = new Iterator_1.default([
                "caloriecount",
                "caloriecount",
                "handpalm",
            ]);
            const days = dates.map((date, id) => ({
                id: id.toString(),
                date,
                day: this.dateTimeProvider.dayOfWeek(date),
                method: nutritionTrackMethodIterator.next(),
                dayType: TrainingInterface_1.WeekDayType.TRAINING_DAY,
                nutritionFacts: {
                    calories: 1500,
                    fats: 200,
                    fibers: 100,
                    protein: 300,
                    carbs: 150,
                },
                calorieBudgetInfo: {
                    calories: {
                        difference: 1200,
                        status: "ALERT",
                    },
                    fats: {
                        difference: 130,
                        status: "WARN",
                    },
                    fibers: {
                        status: "OK",
                        difference: 20,
                    },
                    protein: {
                        difference: 30,
                        status: "WARN",
                    },
                    carbs: {
                        difference: 35,
                        status: "ALERT",
                    },
                },
            }));
            return {
                days,
            };
        };
        this.dateTimeModifier = dateTimeModifier;
        this.dateTimeProvider = dateTimeProvider;
        this.userRepository = userRepository;
        this.nutritionRepository = nutritionRepository;
        this.tokenService = tokenService;
        this.periodPicker = periodPicker;
        this.customerList = customerList;
        this.customerRepository = customerRepository;
        this.dayTypeRepository = dayTypeRepository;
    }
}
exports.default = Nutrition;
//# sourceMappingURL=Nutrition.js.map